import React from "react"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { EnterCode as EnterCodeForm } from "ui/auth/PasswordRecovery/EnterCode"

export const PasswordRecoveryEnterCode = () => (
  <AuthenticationLayout type="signin">
    <EnterCodeForm />
  </AuthenticationLayout>
)
